import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import React, { useState, useRef, useCallback } from "react";
import "../Assets/Css/Table.css";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { axiosConfig } from "../axiosAPI";
import { Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider";
import GlobalDataTable from "../components/GlobalDataTable";

function rowMatchesKeyword(row, keyword) {
  const k = keyword.toLowerCase();
  const hay = [row.code, row.discountPercentage, row.maxDiscountValue, row.startDate, row.endDate, row.uuid]
    .map((x) => String(x ?? "").toLowerCase())
    .join(" ");
  return hay.includes(k);
}

function Promo() {
  const auth = useAuth();
  const promoTableRef = useRef(null);

  const fetchPromoCodesPage = useCallback(
    async ({ pageNo, rowCount, keyword }) => {
      const headers = {
        Authorization: "Bearer " + auth.token,
        "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
      };
      const base = `${process.env.REACT_APP_BASE_URL}/promo-codes`;

      try {
        if (keyword) {
          const response = await axiosConfig.get(base, { headers });
          const all = Array.isArray(response.data.data.result) ? response.data.data.result : [];
          const filtered = all.filter((r) => rowMatchesKeyword(r, keyword));
          const start = (pageNo - 1) * rowCount;
          const slice = filtered.slice(start, start + rowCount);
          return { result: slice, totalCount: filtered.length };
        }

        const params = new URLSearchParams({
          pageNo: String(pageNo),
          rowCount: String(rowCount),
        });
        const response = await axiosConfig.get(`${base}?${params.toString()}`, { headers });
        return {
          result: response.data.data.result,
          totalCount: response.data.data.totalCount,
        };
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        return { result: [], totalCount: 0 };
      }
    },
    [auth.token]
  );
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const headerElement2 = (
    <div className="d-flex align-items-center justify-content-between gap-2">
      <span className="font-bold white-space-nowrap">Edit Promo Code</span>
    </div>
  );
  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">Add Promo Code</span>
    </div>
  );
  const footerContent = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          handleSubmit();
          setVisible(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );
  const footerContent2 = (
    <div className="modal-button">
      <Button
        label="Cancel"
        className="cancel"
        onClick={() => setVisible2(false)}
        autoFocus
      />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          editUser();
          setVisible2(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  const [formData, setFormData] = useState({
    code: "",
    // discountPercentage: "",
    maxDiscountValue: "",
    startDate: "",
    endDate: "",
    totalUsageLimit: "",
    usageLimitPerUser: "1",
    rideTime: "",
    rideKind: "",
    rideDirection: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const resetForm = () => {
    setFormData({
      code: "",
      maxDiscountValue: "",
      startDate: "",
      endDate: "",
      totalUsageLimit: "",
      usageLimitPerUser: "1",
      rideTime: "",
      rideKind: "",
      rideDirection: "",
    });
    setState("");
  };

  const buildUsageLimitFields = (data) => {
    const totalUsageLimit = data.totalUsageLimit === "" ? null : Number(data.totalUsageLimit);
    return {
      totalUsageLimit,
      usageLimitPerUser: totalUsageLimit != null ? 1 : Number(data.usageLimitPerUser || 1),
    };
  };

  const buildRideContextFields = (data) => ({
    rideTime: data.rideTime || null,
    rideKind: data.rideKind || null,
    rideDirection: data.rideDirection || null,
  });

  const handleSubmit = async (e) => {
    // e.preventDefault();
    const data = {
      ...formData,
      discountPercentage: state, // Add phone number to JSON
      ...buildUsageLimitFields(formData),
      ...buildRideContextFields(formData),
    };
    const response = await axiosConfig
      .post(`${process.env.REACT_APP_BASE_URL}/promo-codes`, data, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "application/json",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((res) => {
        promoTableRef.current?.reload();
        resetForm();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Promo code added successfully!",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const deleteUser = async (uuid) => {
    // wait for 1 second before deleting
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await axiosConfig
      .delete(`${process.env.REACT_APP_BASE_URL}/promo-codes/` + uuid, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "application/json",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      })
      .then((res) => {
        promoTableRef.current?.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const editUser = async (uuid) => {
    // wait for 1 second before deleting
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const data = {
      ...formData,
      discountPercentage: formData.discountPercentage,
      ...buildUsageLimitFields(formData),
      ...buildRideContextFields(formData),
    };
    const response = await axiosConfig
      .put(
        `${process.env.REACT_APP_BASE_URL}/promo-codes/` + formData?.uuid,
        data,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      )
      .then((res) => {
        promoTableRef.current?.reload();
        resetForm();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Promo code updated successfully!",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  const statusAction = (rowData) => {
    return (
      <>
        <div className="action-table">
          <a
            className="edit"
            onClick={(e) => {
              setVisible2(true);
              // Format dates for input fields
              const formattedData = {
                ...rowData,
                startDate: rowData.startDate ? new Date(rowData.startDate).toISOString().split('T')[0] : "",
                endDate: rowData.endDate ? new Date(rowData.endDate).toISOString().split('T')[0] : "",
                totalUsageLimit: rowData.totalUsageLimit ?? "",
                usageLimitPerUser: rowData.usageLimitPerUser ?? 1,
                rideTime: rowData.rideTime ?? "",
                rideKind: rowData.rideKind ?? "",
                rideDirection: rowData.rideDirection ?? "",
              };
              setFormData(formattedData);
            }}
          >
            <i className="fa fa-pen"></i>
          </a>
          <a
            className="delete"
            onClick={(e) => {
              deleteUser(rowData.uuid);
            }}
          >
            <i className="fa fa-trash"></i>
          </a>
        </div>
      </>
    );
  };



  const [state, setState] = useState("");
  const handleDisChange = (e) => {
    const { value } = e.target;
    if (value && +value > 100) return setState(100);
    setState(+value);
  };

  // const state = formData.discountPercentage

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              <a
                className="add"
                onClick={() => {
                  resetForm();
                  setVisible(true);
                }}
              >
                <i className="fa fa-plus"></i>
              </a>
              <GlobalDataTable
                ref={promoTableRef}
                fetchPage={fetchPromoCodesPage}
                defaultRowCount={10}
                rowCountOptions={[10, 20, 50, 100]}
                searchPlaceholder="Search code, discount, dates…"
                emptyMessage="No promo codes found."
                headerTitle={
                  <span>
                    <i className="fa fa-tag me-2"></i>
                    Promo codes
                  </span>
                }
                dataKey="uuid"
                showGridlines
                tableStyle={{ minWidth: "700px" }}
              >
                <Column field="code" header="code" style={{ width: "16.66666666%" }}></Column>
                <Column
                  field="discountPercentage"
                  header="discount Percentage"
                  style={{ width: "16.66666666%" }}
                ></Column>
                <Column
                  field="maxDiscountValue"
                  header="max Discount Value"
                  style={{ width: "16.66666666%" }}
                ></Column>
                <Column field="startDate" header="start Date" style={{ width: "16.66666666%" }}></Column>
                <Column field="endDate" header="end Date" style={{ width: "16.66666666%" }}></Column>
                <Column field="totalUsageLimit" header="total usage limit" style={{ width: "16.66666666%" }}></Column>
                <Column field="usageLimitPerUser" header="usage limit per user" style={{ width: "16.66666666%" }}></Column>
                <Column field="rideKind" header="ride kind" style={{ width: "16.66666666%" }}></Column>
                <Column field="rideTime" header="ride time" style={{ width: "16.66666666%" }}></Column>
                <Column field="rideDirection" header="ride direction" style={{ width: "16.66666666%" }}></Column>
                <Column header="" style={{ width: "16.66666666%" }} field="uuid" body={statusAction}></Column>
              </GlobalDataTable>
              <Dialog
                visible={visible}
                modal
                header={headerElement}
                footer={footerContent}
                style={{ width: "50rem" }}
                onHide={() => {
                  if (!visible) return;
                  setVisible(false);
                  resetForm();
                }}
              >
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="code"
                          placeholder="Promo 55"
                          value={formData.code}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Discount Percentage</Form.Label>
                        <Form.Control
                          type="number"
                          max="100"
                          min="0"
                          step="any"
                          name="discountPercentage"
                          placeholder="discountPercentage"
                          value={state}
                          onChange={handleDisChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Max Discount Value</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="any"
                          name="maxDiscountValue"
                          placeholder="maxDiscountValue"
                          value={formData.maxDiscountValue}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          placeholder="startDate"
                          value={formData.startDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          placeholder="endDate"
                          value={formData.endDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Total Usage Limit</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="1"
                          name="totalUsageLimit"
                          placeholder="Leave empty for unlimited"
                          value={formData.totalUsageLimit}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Usage Limit Per User</Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          step="1"
                          name="usageLimitPerUser"
                          placeholder="usageLimitPerUser"
                          value={formData.usageLimitPerUser}
                          onChange={handleChange}
                          disabled={formData.totalUsageLimit !== ""}
                        />
                        {formData.totalUsageLimit !== "" && (
                          <Form.Text muted>Fixed at 1 while a total usage limit is set.</Form.Text>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Kind</Form.Label>
                        <Form.Select name="rideKind" value={formData.rideKind} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="Ride">Regular ride</option>
                          <option value="CityRide">City-to-city ride</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Time</Form.Label>
                        <Form.Select name="rideTime" value={formData.rideTime} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="Immediate">Immediate</option>
                          <option value="Scheduled">Scheduled</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Direction</Form.Label>
                        <Form.Select name="rideDirection" value={formData.rideDirection} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="OneWay">One way</option>
                          <option value="TwoWay">Two way</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>
                </Form>
              </Dialog>
              <Dialog
                visible={visible2}
                modal
                header={headerElement2}
                footer={footerContent2}
                style={{ width: "50rem" }}
                onHide={() => {
                  if (!visible2) return;
                  setVisible2(false);
                  resetForm();
                }}
              >
                <Form onSubmit={editUser}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="code"
                          placeholder="Promo 55"
                          value={formData.code}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Discount Percentage</Form.Label>
                        <Form.Control
                          type="number"
                          max="100"
                          min="0"
                          step="any"
                          name="discountPercentage"
                          placeholder="discountPercentage"
                          value={formData.discountPercentage}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Max Discount Value</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="any"
                          name="maxDiscountValue"
                          placeholder="maxDiscountValue"
                          value={formData.maxDiscountValue}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          placeholder="startDate"
                          value={formData.startDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          placeholder="endDate"
                          value={formData.endDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Total Usage Limit</Form.Label>
                        <Form.Control
                          type="number"
                          min="0"
                          step="1"
                          name="totalUsageLimit"
                          placeholder="Leave empty for unlimited"
                          value={formData.totalUsageLimit}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Usage Limit Per User</Form.Label>
                        <Form.Control
                          type="number"
                          min="1"
                          step="1"
                          name="usageLimitPerUser"
                          placeholder="usageLimitPerUser"
                          value={formData.usageLimitPerUser}
                          onChange={handleChange}
                          disabled={formData.totalUsageLimit !== ""}
                        />
                        {formData.totalUsageLimit !== "" && (
                          <Form.Text muted>Fixed at 1 while a total usage limit is set.</Form.Text>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Kind</Form.Label>
                        <Form.Select name="rideKind" value={formData.rideKind} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="Ride">Regular ride</option>
                          <option value="CityRide">City-to-city ride</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Time</Form.Label>
                        <Form.Select name="rideTime" value={formData.rideTime} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="Immediate">Immediate</option>
                          <option value="Scheduled">Scheduled</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Ride Direction</Form.Label>
                        <Form.Select name="rideDirection" value={formData.rideDirection} onChange={handleChange}>
                          <option value="">Any</option>
                          <option value="OneWay">One way</option>
                          <option value="TwoWay">Two way</option>
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </div>
                </Form>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Promo;
